import { render } from "./download-forms-page.vue?vue&type=template&id=04d9bb22"
import script from "./download-forms-page.vue?vue&type=script&lang=js"
export * from "./download-forms-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__